import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import sessionManager from '../utils/sessionManager';

const SessionDebugger = () => {
  const { user, isAuthenticated, loading } = useAuth();
  const [sessionInfo, setSessionInfo] = useState(null);
  const [showDebugger, setShowDebugger] = useState(false);

  useEffect(() => {
    const updateSessionInfo = () => {
      const info = sessionManager.getSessionInfo();
      setSessionInfo(info);
    };

    updateSessionInfo();
    const interval = setInterval(updateSessionInfo, 1000);

    return () => clearInterval(interval);
  }, []);

  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  if (!showDebugger) {
    return (
      <button
        onClick={() => setShowDebugger(true)}
        className="fixed bottom-4 right-4 bg-red-600 text-white px-3 py-2 rounded-lg text-xs font-mono z-50"
      >
        🔐 Debug
      </button>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 bg-dark-950/90 text-white p-4 rounded-lg text-xs font-mono max-w-sm z-50 border border-gray-600">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-bold text-primary">🔐 Session Debug</h3>
        <button
          onClick={() => setShowDebugger(false)}
          className="text-dark-400 hover:text-white"
        >
          ✕
        </button>
      </div>
      
      <div className="space-y-2">
        <div>
          <span className="text-dark-400">Auth State:</span>
          <span className={`ml-2 ${isAuthenticated ? 'text-green-400' : 'text-red-400'}`}>
            {loading ? 'Loading...' : isAuthenticated ? 'Authenticated' : 'Not Authenticated'}
          </span>
        </div>
        
        <div>
          <span className="text-dark-400">User Role:</span>
          <span className="ml-2 text-blue-400">{user?.role || 'None'}</span>
        </div>
        
        <div>
          <span className="text-dark-400">User ID:</span>
          <span className="ml-2 text-yellow-400">{user?.id || 'None'}</span>
        </div>
        
        {sessionInfo && (
          <>
            <div>
              <span className="text-dark-400">Session ID:</span>
              <span className="ml-2 text-purple-400">{sessionInfo.sessionId || 'None'}</span>
            </div>
            
            <div>
              <span className="text-dark-400">Has Token:</span>
              <span className={`ml-2 ${sessionInfo.hasToken ? 'text-green-400' : 'text-red-400'}`}>
                {sessionInfo.hasToken ? 'Yes' : 'No'}
              </span>
            </div>
            
            <div>
              <span className="text-dark-400">Last Activity:</span>
              <span className="ml-2 text-dark-300">
                {sessionInfo.lastActivity ? new Date(sessionInfo.lastActivity).toLocaleTimeString() : 'None'}
              </span>
            </div>
            
            <div>
              <span className="text-dark-400">Session Valid:</span>
              <span className={`ml-2 ${sessionInfo.isValid ? 'text-green-400' : 'text-red-400'}`}>
                {sessionInfo.isValid ? 'Yes' : 'No'}
              </span>
            </div>
          </>
        )}
        
        <div className="pt-2 border-t border-gray-600">
          <span className="text-dark-400">Current Path:</span>
          <span className="ml-2 text-dark-300">{window.location.pathname}</span>
        </div>
        
        <div className="pt-2 space-y-1">
          <button
            onClick={() => sessionManager.clearSession()}
            className="w-full bg-red-600 hover:bg-red-500 text-white px-2 py-1 rounded text-xs"
          >
            Clear Session
          </button>
          <button
            onClick={() => {
              console.log('🔍 Session Info:', sessionManager.getSessionInfo());
              console.log('🔍 Auth Context:', { user, isAuthenticated, loading });
            }}
            className="w-full bg-blue-600 hover:bg-blue-500 text-white px-2 py-1 rounded text-xs"
          >
            Log Debug Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionDebugger;
